Object.defineProperty (module.exports, "__esModule", { value: true }),
module.exports.BlendMode = module.exports.default = {
	ADD: "add",
	ALPHA: "alpha",
	DARKEN: "darken",
	DIFFERENCE: "difference",
	ERASE: "erase",
	HARDLIGHT: "hardlight",
	INVERT: "invert",
	LAYER: "layer",
	LIGHTEN: "lighten",
	MULTIPLY: "multiply",
	NORMAL: "normal",
	OVERLAY: "overlay",
	SCREEN: "screen",
	SHADER: "shader",
	SUBTRACT: "subtract"
};